export const WorkspaceConfig_Search = {
    name: 'search',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'searchPanel', visible: true, factor: 1.5 / 5, min: 450,
                data: {}
            },
            {
                name: 'RightPanel', key: 'dataViewer', visible: true, factor: 3.5 / 5, min: 1100,
                data: {}
            },
        ]
    }
};
